module.exports = __webpack_public_path__ + "img/badge240.07dcf3a0.png";